import React, { Fragment } from "react";
import FilterTool from "./FilterTool";

interface Props {
  columns?: any[];
  formik: any;
  data?: any[];
  originalData?: any[];
  additionalField?: string[];
  filterFields?: string[];
  dateFieateHierarchyFields?: string[];
  getValue?: (value: string, type: string) => string;
  isPreferUseGetValue?: boolean;
  filterInfo: {
    open: boolean;
    columnId: string;
    position?: {
      x?: number;
      y?: number;
    };
  };
  setFilterInfo?: React.Dispatch<
    React.SetStateAction<{
      open: boolean;
      columnId: string;
      position?: {
        x?: number;
        y?: number;
      };
    }>
  >;
  onFilter: (props?: { isClearFilter: boolean }) => void;
  fetchFilterOptions?: (columnId: string) => Promise<{
    options: { value: string; label: string }[];
    isShowEmptyDate: boolean;
  }>;
}

const FilterHeader = ({
  columns,
  formik,
  data,
  originalData,
  additionalField,
  dateFieateHierarchyFields,
  filterFields,
  filterInfo,
  setFilterInfo,
  onFilter,
  getValue,
  isPreferUseGetValue,
  fetchFilterOptions,
}: Props) => {
  return (
    <Fragment>
      {filterInfo.position && (
        <FilterTool
          columns={columns}
          formik={formik}
          filterInfo={filterInfo}
          additionalField={additionalField}
          filterFields={filterFields}
          dateFieateHierarchyFields={dateFieateHierarchyFields}
          onFilter={onFilter}
          setFilterInfo={setFilterInfo}
          originalData={originalData}
          data={data}
          getValue={getValue}
          isPreferUseGetValue={isPreferUseGetValue}
          fetchFilterOptions={fetchFilterOptions}
        />
      )}
    </Fragment>
  );
};

export default FilterHeader;
